export const DEFAULT_TOGGLE_ON_COLOR = "#3977a2";
export const DENIED_COLOR = "#dc3545";
export const APPROVED_COLOR = "#28a745";
export const COMPLETE_COLOR = "#498ab2";
export const INCOMPLETE_COLOR = "#8e8e8e";
export const OBLIGATION_COLOR = "#FDB81E";
export const NO_DECISION_COLOR = "#ADB5BD";
